module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_resort-80b325c27f1cea3219d1a7fe7bffb005.webp";